import React from "react";
import "./Resume.css";

const Resume = () => {
  return (
    <div className="resume-page">
      <iframe
        src="/Thomas_Conrad_Resume.pdf"
        title="Resume PDF"
      />
    </div>
  );
};

export default Resume;
